
import Vue, { PropType } from 'vue';
import { LMarker, LTooltip, LIcon } from 'vue2-leaflet';
import { Position } from '@/components/configuration/DeviceMap.vue';

export default Vue.extend({
	components: { LMarker, LTooltip, LIcon },

	props: {
		position: {
			type: Object as PropType<Position>,
			default: (): Position => ({ lat: 0, lng: 0 }),
		},
		id: { type: Number, default: 0 },
		name: { type: String, default: 'default-marker' },
		guid: { type: String, default: '' },
		channel: { type: Number, default: undefined },
		visible: { type: Boolean, default: true },
		active: { type: Boolean, default: false },
		isLuminaire: { type: Boolean, default: true },
		isMovementSensor: { type: Boolean, default: false },
		isLightLevelSensor: { type: Boolean, default: false },
		isGateway: { type: Boolean, default: false },
		isOtherSensor: { type: Boolean, default: false },
		draggable: { type: Boolean, default: false },
	},

	mounted() {
		(this.$refs.marker as LMarker).mapObject?.on('click', this.onClick);
		(this.$refs.marker as LMarker).mapObject?.on('dragend', this.onDragStop);
	},

	computed: {
		icon(): string {
			const baseUrl = process.env.BASE_URL;
			let iconName = '';

			if (this.active) {
				iconName = 'green_box.jpg';
			} else if (this.isLuminaire) {
				iconName = this.isLightLevelSensor
					? this.isMovementSensor
						? 'blueredyellow_box.jpg'
						: 'blueyellow_box.jpg'
					: this.isMovementSensor
					? 'bluered_box.jpg'
					: 'blue_box.jpg';
			} else if (this.isGateway) {
				iconName = 'blue_triangle.png';
			} else {
				iconName = this.isLightLevelSensor
					? this.isMovementSensor
						? 'redyellow_box.jpg'
						: 'yellow_box.jpg'
					: this.isMovementSensor
					? 'red_box.jpg'
					: 'purple_box.jpg';
			}

			return `${baseUrl}map/${iconName}`;
		},
	},

	methods: {
		onClick() {
			this.$emit('click');
		},

		onDragStop() {
			this.$emit('locUpdated', (this.$refs.marker as LMarker).mapObject.getLatLng(), this.id);
		},
	},
});
